import { connect } from 'react-redux';
import { actions, selectors } from '../../../CollectionPanel/redux';
import { getIsDeviationInitialized, getTotalCountOfCollectedDeviations, getUserCollectionsCount, getUserCollectionsHasMore } from '../../../CollectionPanel/redux/selectors';
import { removeQueues } from '../../../Notifications/redux/actionCreators';
const mapStateToProps = (state, { collectibleDeviation: { deviationId  } , isPrivateCollections  })=>({
        isInitialized: getIsDeviationInitialized(state, deviationId, isPrivateCollections),
        collectionsCount: getUserCollectionsCount(state, deviationId, isPrivateCollections),
        hasMoreCollections: getUserCollectionsHasMore(state, deviationId, isPrivateCollections),
        selectedFolderIds: selectors.getSelectedFolderIds(state, deviationId, isPrivateCollections),
        totalCountOfPrivatelyCollectedDeviations: isPrivateCollections ? getTotalCountOfCollectedDeviations(state, deviationId, isPrivateCollections) : undefined
    });
const mapDispatchToProps = {
    initializeCollectionsForDeviation: actions.initializeDeviation,
    commitCollections: actions.commitCollectionsCustom,
    removeQueues
};
export default connect(mapStateToProps, mapDispatchToProps);
